<template>
  <Transition mode="out-in" name="page">
    <slot></slot>
  </Transition>
</template>

<style scoped lang="scss">
/* 过度动画配置代码 */
.page-enter-from,
.page-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.page-enter-to,
.page-leave-from {
  opacity: 1;
}

.page-enter-active {
  transition: all 0.4s ease;
}

.page-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.6, 0.6, 1);
}
</style>